import React, { useEffect, useState } from 'react';
import { Zap } from 'lucide-react';
export function StatusBar() {
  // Start at 5 minutes 42 seconds (342 seconds)
  const [timeLeft, setTimeLeft] = useState(342);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return <div className="fixed top-0 left-0 right-0 z-50 bg-coral-500 text-white py-3 px-4 shadow-md" data-id="element-80">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-center text-sm sm:text-base font-medium text-center gap-2" data-id="element-81">
        <div className="flex items-center gap-2" data-id="element-82">
          <Zap className="w-4 h-4 fill-current animate-pulse" data-id="element-83" />
          <span data-id="element-84">FLASH SALE: 95% OFF ends in</span>
          <span className="font-bold bg-white/20 px-2 py-0.5 rounded tabular-nums" data-id="element-85">
            {formattedTime}
          </span>
        </div>
        <span className="hidden sm:inline" data-id="element-86">—</span>
        <span data-id="element-87">Get the 7-Day Reset for just $27!</span>
      </div>
    </div>;
}